import React, { Component } from "react";
import { connect } from 'react-redux';
import './style.css'

class Loader extends Component {
  constructor(props, context) {
    super(props);
    this.state = {

    }
  }
  
  render() {
    return (
      <>
      {this.props.isLoaderShown ? <div className="Loader">
        <div className="Loader-cell">
          <div className="Loader-outer">
            <div className="lds-ripple"><div></div><div></div></div>
          </div>
        </div>
      </div> : null}
      </>
      
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoaderShown: state.loaderReducer.isLoading,
  }
};

export default connect(mapStateToProps)(Loader);